import { createFile } from '#apps/client-web/features/file-storage/helpers';
import { type FileContent } from '#apps/client-web/features/file-storage/services/file-storage';
import {
  parseFloatOrUndefined,
  parseIntOrUndefined,
} from '#apps/client-web/utils/helpers';

import { type Attachment } from '#packages/data-collection/models/common/attachment';
import { type AuditWindowsFormEntry } from '#packages/data-collection/models/audit-windows-form';

import { type EditAuditFormWindowsEntryData } from './types';

export const fromFormData = (
  formData: EditAuditFormWindowsEntryData,
  attachments?: Attachment[],
): AuditWindowsFormEntry => ({
  section: formData.section,
  directionFacing: formData.directionFacing,
  quantity: parseIntOrUndefined(formData.quantity),
  isUsingMetrics: formData.isUsingMetrics ?? false,
  widthInFeet: parseFloatOrUndefined(formData.widthInFeet),
  widthInInches: parseFloatOrUndefined(formData.widthInInches),
  heightInFeet: parseFloatOrUndefined(formData.heightInFeet),
  heightInInches: parseFloatOrUndefined(formData.heightInInches),
  widthInMeters: parseFloatOrUndefined(formData.widthInMeters),
  heightInMeters: parseFloatOrUndefined(formData.heightInMeters),
  area: formData.area,
  operability: formData.operability,
  frameMaterial: formData.frameMaterial,
  glazingPanes: formData.glazingPanes,
  notes: formData.notes,
  attachments,
});

export const toFormData = (
  entryData: AuditWindowsFormEntry | undefined,
  files?: (FileContent | undefined)[],
): Partial<EditAuditFormWindowsEntryData> => ({
  section: entryData?.section,
  directionFacing: entryData?.directionFacing,
  quantity: entryData?.quantity?.toString(),
  isUsingMetrics: entryData?.isUsingMetrics ?? false,
  widthInFeet: entryData?.widthInFeet?.toString(),
  widthInInches: entryData?.widthInInches?.toString(),
  heightInFeet: entryData?.heightInFeet?.toString(),
  heightInInches: entryData?.heightInInches?.toString(),
  widthInMeters: entryData?.widthInMeters?.toString(),
  heightInMeters: entryData?.heightInMeters?.toString(),
  area: entryData?.area,
  operability: entryData?.operability,
  frameMaterial: entryData?.frameMaterial,
  glazingPanes: entryData?.glazingPanes,
  notes: entryData?.notes,
  attachments: entryData?.attachments?.map((attachment, index) => ({
    ...attachment,
    file: createFile({
      content: files![index]!,
      name: attachment.name,
      mimeType: attachment.mimeType,
    }),
  })),
});
